import React, { ReactNode, useContext, useState } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import Brand from "../../../layout/Brand/Brand";
import Navigation, {
  NavigationLine,
} from "../../../layout/Navigation/Navigation";
import User from "../../../layout/User/User";
import {
  componentPagesMenu,
  dashboardPagesMenu,
  demoPagesMenu,
  footerMenu,
  gettingStartedPagesMenu,
  pageLayoutTypesPagesMenu,
  vyuMenu,
  vyuRestrictedMenu,
} from "../../../menu";
import ThemeContext from "../../../contexts/themeContext";
import Card, { CardBody } from "../../../components/bootstrap/Card";
import Hand from "../../../assets/img/hand.png";
import HandWebp from "../../../assets/img/hand.webp";
import Icon from "../../../components/icon/Icon";
import Button from "../../../components/bootstrap/Button";
import useDarkMode from "../../../hooks/useDarkMode";
import Aside, {
  AsideBody,
  AsideFoot,
  AsideHead,
} from "../../../layout/Aside/Aside";
import DashboardMenu from "../../_common/DashboardMenu";
import { dashboardMenu } from "../../../store/apiSlice";
import store from "../../../store/store";
import "./DefaultAside.css";
const DefaultAside = () => {
  const { asideStatus, setAsideStatus } = useContext(ThemeContext);
  const [doc, setDoc] = useState(
    localStorage.getItem("facit_asideDocStatus") === "false" || false
  );

  const { t } = useTranslation(["translation", "menu"]);

  const { darkModeStatus } = useDarkMode();

  let isViewOnly = false;
  const userInfoString = localStorage.getItem("userInfo");

  if (userInfoString) {
    try {
      const userInfo = JSON.parse(userInfoString);
      const userRoles = userInfo?.roles || [];
      isViewOnly = userRoles.some(
        (role: { roleName: string }) => role.roleName === "VIEW ONLY"
      );
    } catch (error) {
      console.error("Failed to parse user info from localStorage", error);
    }
  }

  return (
    <>
      <Aside className="asideHover">
        <AsideHead>
          <Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} />
        </AsideHead>

        <AsideBody>
          {!doc && !isViewOnly && (
            <>
              <Navigation menu={dashboardMenu} id="dashboard" />
              <Navigation menu={vyuMenu} id="aside-vyu" />
              <NavigationLine />
            </>
          )}
          {!doc && isViewOnly && (
            <>
              <Navigation menu={dashboardMenu} id="dashboard" />
              <Navigation menu={vyuRestrictedMenu} id="aside-vyu" />
              <NavigationLine />
            </>
          )}

          {doc && (
            <>
              <Navigation menu={gettingStartedPagesMenu} id="aside-docMenu" />
              <NavigationLine />
              <Navigation menu={componentPagesMenu} id="aside-componentsMenu" />
              <NavigationLine />
            </>
          )}

          {asideStatus && doc && (
            <Card className="m-3 ">
              <CardBody className="pt-0">
                <img
                  srcSet={HandWebp}
                  src={Hand}
                  alt="Hand"
                  width={130}
                  height={130}
                />
                <p
                  className={classNames("h4", {
                    "text-dark": !darkModeStatus,
                    "text-light": darkModeStatus,
                  })}
                >
                  {t("Everything is ready!") as ReactNode}
                </p>
                <Button
                  color="info"
                  isLight
                  className="w-100"
                  onClick={() => {
                    localStorage.setItem("facit_asideDocStatus", "false");
                    setDoc(false);
                  }}
                >
                  {t("Demo Pages") as ReactNode}
                </Button>
              </CardBody>
            </Card>
          )}
        </AsideBody>
        <AsideFoot>
          <Navigation menu={footerMenu} id="aside-vyu-footer" />
          <NavigationLine />
          <User />
        </AsideFoot>
      </Aside>
    </>
  );
};

export default DefaultAside;
